(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('LanguageLocalizationDeleteController',LanguageLocalizationDeleteController);

    LanguageLocalizationDeleteController.$inject = ['$uibModalInstance', 'entity', 'LanguageLocalization'];

    function LanguageLocalizationDeleteController($uibModalInstance, entity, LanguageLocalization) {
        var vm = this;

        vm.languageLocalization = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            LanguageLocalization.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
